"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = exports.skeletonKeyframes = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = require("@emotion/react");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  0% {\n    background-position: -200px 0;\n  }\n  100% {\n    background-position: calc(200px + 100%) 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var skeletonKeyframes = (0, _react.keyframes)(_templateObject());
/*
  inline-blocks add a little bit of magic margin underneath it which screws up the spacing.
  The solution for now was to just make it a display block
  https://stackoverflow.com/questions/1833734/display-inline-block-extra-margin

  The Table components border-spacing gets collapsed by the pagination rows margin-top. That doesnt
  happen on skeleton item, so we need to force remove any margin bottom to prevent any issues
*/

exports.skeletonKeyframes = skeletonKeyframes;

var skeletonItem = function skeletonItem(_ref) {
  var theme = _ref.theme,
      duration = _ref.duration,
      isCircle = _ref.isCircle;
  return /*#__PURE__*/(0, _react.css)("background-color:", theme.color.monochrome.light, ";background-image:linear-gradient(\n    90deg,\n    ", theme.color.monochrome.light, ",\n    ", theme.color.monochrome.medium, ",\n    ", theme.color.monochrome.light, "\n  );background-size:200px 100%;background-repeat:no-repeat;display:block;width:100%;animation:", skeletonKeyframes, " ", duration, "s ease-in-out infinite;border:1px solid ", theme.color.monochrome.medium, ";border-radius:", isCircle ? '50%' : '4px', ";opacity:0.41;&:last-of-type{margin-bottom:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:skeletonItem;"));
};

var styles = {
  skeletonItem: skeletonItem
};
exports.styles = styles;
//# sourceMappingURL=Skeleton.styles.js.map